// 260624: 블로그 글 — '여행 어디가지?' 존(지그재그) + 글 상세. 비로그인 열람.
export default [
  {
    path: '/travel',
    component: () => import('@/views/post/TravelZone.vue'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: '여행 어디갈까?'
    }
  },
  {
    path: '/post/:postNo(\\d+)',
    component: () => import('@/views/post/PostDetail.vue'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: '블로그'
    }
  }
];
